import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/dashboard',
    name: 'DashboardPage',
    component: () => import('@/modules/myServices/views/DashboardPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })

  // Backward-compatibility: keep old bookmarks / external links (e.g. payment
  // return URLs) working after the /my-services → /dashboard rename.
  router.addRoute({
    path: '/my-services',
    redirect: '/dashboard',
  })
}
